import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { TrackingDashboardTemplate } from 'themes/modules/dashboard/pages';
import { TrackingDashboardViewStore } from 'modules/dashboard/stores';

@setCurrentView(rootStore => new TrackingDashboardViewStore(rootStore), 'trackingDashboardViewStore')
@observer
class TrackingDashboard extends React.Component {
	componentWillUnmount() {
		if (this.props.trackingDashboardViewStore && this.props.trackingDashboardViewStore.destroy) {
			this.props.trackingDashboardViewStore.destroy();
		}
	}

	render() {
		return <TrackingDashboardTemplate {...this.props} viewStore={this.props.trackingDashboardViewStore} />;
	}
}

export default TrackingDashboard;